import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  url: "",
  image: null,
  coords: null,
  extent: null,
  lat: null,
  lng: null,
};

const mapa = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_GOOGLE_MAP_LAT_LNG_REQUEST:
    case actionTypes.GET_MAPA_EXTENT_COORDS_REQUEST:
    case actionTypes.GET_MAPA_IMAGE_REQUEST:
    case actionTypes.GET_MAPA_URL_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.GET_MAPA_URL_SUCCESS: {
      return { ...state, isLoading: false, url: action.res.Data };
    }

    case actionTypes.GET_GOOGLE_MAP_LAT_LNG_SUCCESS: {
      const { lat, lng } = action.res;
      return { ...state, isLoading: false, lat, lng };
    }

    case actionTypes.CHANGE_MAPA_EXTENT_COORDS:
      const { extent, coords } = action.res;
      return { ...state, isLoading: false, coords, extent, url: "" };

    case actionTypes.GET_MAPA_EXTENT_COORDS_SUCCESS: {
      const { extent, coords } = action.res;
      let url = coords ? state.url.replace("features:[]", "features:" + JSON.stringify(coords.map(x => { return { coordinates: x.coordinates } }))) : state.url;
      url = extent ? url.replace(/locateBoundingBox: \"-\d+\.\d+,-\d+\.\d+,-\d+\.\d+,-\d+\.\d+\"/,
        "locateBoundingBox: " + JSON.stringify(extent).replace("[", "\"").replace("]", "\"")) : url;
      return { ...state, isLoading: false, coords, extent, url };
    }

    case actionTypes.CHANGE_MAPA_IMAGE:
    case actionTypes.GET_MAPA_IMAGE_SUCCESS: {
      const { image } = action.res;
      return { ...state, isLoading: false, image };
    }

    case actionTypes.GET_GOOGLE_MAP_LAT_LNG_FAILURE:
    case actionTypes.GET_MAPA_EXTENT_COORDS_FAILURE:
    case actionTypes.GET_MAPA_IMAGE_FAILURE:
    case actionTypes.GET_MAPA_URL_FAILURE:
      return _initState;

    default:
      return state;
  }
};

export default mapa;
